module.exports = __webpack_public_path__ + "assets/img/img_2010.2febd633.jpg";